import { render, staticRenderFns } from "./Certificado.vue?vue&type=template&id=4f7bf134&scoped=true&lang=pug&"
import script from "./Certificado.vue?vue&type=script&lang=js&"
export * from "./Certificado.vue?vue&type=script&lang=js&"
import style0 from "./Certificado.vue?vue&type=style&index=0&id=4f7bf134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7bf134",
  null
  
)

export default component.exports